export default __webpack_public_path__ + "static/media/profile2.dbd15e3e.jpg";